var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { useEffect, useState } from 'react';
import { useTranslation } from "../../../hooks/useTranslation";
import { DRILL_TYPE_INFORMATION } from "../constants/drill";
import { getWorkMakerAvailableDrillTypeListFromSchoolType } from "../utils/WorkMaker";
/**
 * 教科で絞り込む箇所において、絞り込まずに全ての教科を表示する選択肢。
 * 全ての学校種にて選択可能
 */
export var allKyokaDrillTypeItem = {
    label: '全教科',
    value: 0,
};
/**
 * 学校種毎にワークメーカーで利用可能なドリルタイプの表示要素を返す
 */
export var useSelectionDrillType = function (schoolType) {
    var t = useTranslation().t;
    var _a = useState([allKyokaDrillTypeItem]), drillTypeItems = _a[0], setDrillTypeItems = _a[1];
    useEffect(function () {
        if (!schoolType)
            return;
        // 現在利用できる教科を取得
        var availableDrillTypeList = getWorkMakerAvailableDrillTypeListFromSchoolType(schoolType);
        var drillTypeItemsBySchoolType = availableDrillTypeList
            .sort(function (a, b) { return DRILL_TYPE_INFORMATION[a].order - DRILL_TYPE_INFORMATION[b].order; })
            .map(function (drillTypeId) {
            var _a = DRILL_TYPE_INFORMATION[drillTypeId], displayValue = _a.displayValue, id = _a.id;
            return {
                label: schoolType === 'COMPULSORY_EDUCATION_SCHOOL'
                    ? displayValue.withSchool || displayValue.standard
                    : displayValue.standard,
                value: id,
            };
        });
        setDrillTypeItems(__spreadArrays([allKyokaDrillTypeItem], drillTypeItemsBySchoolType));
    }, [schoolType, t]);
    return drillTypeItems;
};
